import React from 'react';
import { Wrench, Stethoscope, Scale, Briefcase, Globe, Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';

const Categories = () => {
  const categories = [
    {
      icon: Wrench,
      title: 'Engineering (JEE)',
      description: 'Top engineering colleges and courses',
      color: 'text-primary',
      bgColor: 'bg-primary'
    },
    {
      icon: Stethoscope,
      title: 'Medical (NEET)',
      description: 'Medical colleges and MBBS programs',
      color: 'text-danger',
      bgColor: 'bg-danger'
    },
    {
      icon: Scale,
      title: 'Law',
      description: 'Law colleges and legal studies',
      color: 'text-success',
      bgColor: 'bg-success'
    },
    {
      icon: Briefcase,
      title: 'Management',
      description: 'MBA and management programs',
      color: 'text-info',
      bgColor: 'bg-info'
    },
    {
      icon: Globe,
      title: 'Arts & Humanities',
      description: 'Liberal arts and humanities courses',
      color: 'text-warning',
      bgColor: 'bg-warning'
    },
    {
      icon: Calculator,
      title: 'JoSAA Predictor',
      description: 'Predict IIT, NIT, IIIT admissions',
      color: 'text-info',
      bgColor: 'bg-info',
      link: '/josaa-personalized-list'
    }
  ];

  return (
    <section className="py-3 py-md-5 bg-light">
      <div className="container">
        <div className="text-center mb-4 mb-md-5 px-2">
          <h2 className="h1 fw-bold text-dark mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.5rem)' }}>
            Popular College Categories
          </h2>
          <p className="lead text-muted" style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
            Explore colleges by your field of interest
          </p>
        </div>

        <div className="row g-2 g-md-4 justify-content-center px-2 px-md-0 categories-mobile-grid">
          {categories.map((category, index) => {
            const Icon = category.icon;
            const CategoryComponent = category.link ? Link : 'div';
            const categoryProps = category.link ? { to: category.link } : {};
            
            return (
              <div key={index} className="col-6 col-md-4 col-lg-2">
                <CategoryComponent 
                  {...categoryProps}
                  className={`category-card card h-100 border-0 shadow-sm text-center p-2 p-md-3 ${category.link ? 'text-decoration-none' : ''}`}
                >
                  <div className={`feature-icon ${category.bgColor} bg-opacity-10 mb-1 mb-md-3 mx-auto`} style={{ width: 'clamp(2rem, 6vw, 4rem)', height: 'clamp(2rem, 6vw, 4rem)' }}>
                    <Icon className={category.color} size={24} />
                  </div>
                  <h5 className="card-title fw-bold text-dark mb-1 mb-md-2" style={{ fontSize: 'clamp(0.7rem, 2.5vw, 1.25rem)', lineHeight: '1.1' }}>
                    {category.title}
                  </h5>
                  <p className="card-text text-muted mb-0" style={{ fontSize: 'clamp(0.6rem, 2vw, 0.875rem)', lineHeight: '1.2' }}>
                    {category.description}
                  </p>
                </CategoryComponent>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;